exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".E8XbiC95Km6SK8NbHtDvB{position:fixed;pointer-events:\"none\";z-index:1000;top:0;font-size:12px;font-weight:400}html[dir] .E8XbiC95Km6SK8NbHtDvB{border-width:1px;border-style:solid;padding:0 4px;background:\"[theme:neutralTertiary, default:#a6a6a6]\"}html[dir=ltr] .E8XbiC95Km6SK8NbHtDvB{left:0}html[dir=rtl] .E8XbiC95Km6SK8NbHtDvB{right:0}._3SEVeVGQ2GDXQ237Iuk8_x{color:\"[theme:themeDark, default:#0D62AA]\";font-weight:600}._3GSwlxpiac4iOcgGiYg1-T{-webkit-animation-duration:.666s;animation-duration:.666s}html[dir] .FVtUvT8aG5TO-esh6onjN{padding:5px 0}html[dir=ltr] ._2XmAO_mgvcx7Qekdrpzhrw{margin-right:-6px}html[dir=rtl] ._2XmAO_mgvcx7Qekdrpzhrw{margin-left:-6px}._1cdKueU8Vv68X9B1ekHD13{color:\"[theme:white, default:#ffffff]\";font-weight:600;width:50px}html[dir] ._1cdKueU8Vv68X9B1ekHD13{background:\"[theme:themePrimary, default:#0078D7]\";border-radius:5px;text-align:center}", ""]);

// exports
exports.locals = {
	"dragPreview": "E8XbiC95Km6SK8NbHtDvB",
	"unreadCount": "_3SEVeVGQ2GDXQ237Iuk8_x",
	"addedNode": "_3GSwlxpiac4iOcgGiYg1-T",
	"loadingSpinner": "FVtUvT8aG5TO-esh6onjN",
	"favoriteButton": "_2XmAO_mgvcx7Qekdrpzhrw",
	"packageNew": "_1cdKueU8Vv68X9B1ekHD13"
};